<template lang="pug">
  div(v-if='dataDetail')
    div.alertDetail
      // v-if='detailAlert'
      div.alertDetail__header
        template
          div(v-if="link = true" @click="closeDetail")
            ods-icon.detail-icon(
              name="arrow-left"
              size="18")
        div.alertDetail__header-title {{ $t(dataDetail.name) }}
        div.alertDetail__level
          template(v-if="dataDetail.severity === 'high'")
            ods-tooltip(content="Alerta importante" placement="top")
              div.table-dot(class="table-dot--danger")
          template(v-else-if="dataDetail.severity === 'medium'")
            ods-tooltip(content="Alerta moderada" placement="top")
              div.table-dot(class="table-dot--medium")
          template(v-else-if="dataDetail.severity === 'low'")
            ods-tooltip(content="Alerta baja" placement="top")
              div.table-dot(class="table-dot--warning")
          template(v-else)
            ods-tooltip(content="Alerta importante" placement="top")
              div.table-dot
          div.alertDetail__level-text
            p NIVEL {{ $t(dataDetail.severity) }}
      div.alertDetail__cat
        p ALERTA - {{ $t(dataDetail.category) }} {{ $t(dataDetail.subCategory) }}
      template
        ods-table.alertDetail__info(:data="tableDataInfo" style="width: 100%" )
          ods-table-column.alertDetail__colum(
            prop="fecha"
            label="Fecha"
            width="100")
          ods-table-column.alertDetail__colum(
            prop="hora"
            label="hora"
            width="60")
          ods-table-column.alertDetail__colum(
            prop="address"
            label="Localization")
      template.alertDetail__description()
          ods-col.alertDetail__description-text
            p {{ $t(dataDetail.description) }} {{ $t('hour') }}
</template>
<script>

// import mapElements from '@/mixins/mapElements'

export default {
  name: 'AlertsDetail',
  props: {
    dataChart: {
      type: Object
    },
    dataDetail: {

    },
    title: 'Titulo de prop'
  },
  data () {
    return {
      chart: [],
      tableDataInfo: [{
        fecha: this.dataDetail.fecha,
        hora: this.dataDetail.hour,
        address: 'Centro - Francisco González Díaz '
      }],
      detailAlert: false,
      data: null
    }
  },
  computed: {
  },
  methods: {
    showAlertDetail () {
      this.detailAlert = true
    },
    closeDetail () {
      this.$emit('closeChild')
    }
    // changeDate() {
    //   const component = this
    //   console.log(this.formatLocaleDate(this.dataDetail.timestamp));
    //   var dateFormated = this.formatLocaleDate(this.dataDetail.timestamp) + ' - ' + this.formatLocaleHour(this.dataDetail.timestamp)
    //   console.log('dateFormated--->', dateFormated);
    // }
  },
  watch: {
    dataChart (newVal, oldVal) {
      const component = this
      component.chart = newVal
    }
  },
  created () {
    this.chart = this.dataChart
  },
  mounted () {
    // const component = this
    // console.log(this.link);
  }
}
</script>

<style lang="scss" scoped>
.slide-AlertDetail-enter, .slide-AlertDetail-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
/deep/ .ods-table .cell, .ods-table th div {
  /* padding-left: rem(24); */
}
/deep/ .ods-table th.is-leaf{
  border-bottom: none;
  padding: rem(10) rem(0) rem(0) rem(0);
  &:first-child{
    padding-left: rem(20);
  }
}
/deep/ .ods-table td{
  border-bottom: none;
  cursor: initial;
  padding: rem(0) rem(0) rem(0) rem(0);

}
/deep/ .ods-table td{
  &:last-child{
    padding: rem(0) rem(16) rem(0) rem(0);
  }
  &:first-child{
    padding-left: rem(20);
  }
}
.alertDetail{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  &__header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ods-icon-arrow-left{
      cursor: pointer;
      font-size: rem(23);
      color: #2e6c99;
    }
  }
  &__level{
    display: flex;
  }
  &__level-text{
    margin: rem(0) rem(0) rem(0) rem(10);
    display: inline-table;
    font-size: rem(9);
    p {
      min-width: rem(55);
      text-transform: uppercase;
    }
  }
  &__cat{
    color: #6E767D;
    font-size: rem(10);
    margin: rem(16) rem(0) rem(0);
    text-transform: uppercase;
    font-weight: 500;
  }
  &__info{
    /* padding: 0 20px */
    background:  $--color-primary-light-9;
    box-sizing: content-box;
    border-radius: rem(4);
    margin: rem(20) rem(0);

      /deep/ .ods-scrollbar{
        height: auto !important;
        &__wrap{
          min-height: 47px;
          /* overflow: scroll; */
          scrollbar-width: none;
        }
      }
  }
  &__header-title{
    font-size: rem(16);
    font-weight: 500;
    width: 100%;
    padding: 0 0 0 rem(16);
  }
  &__description-text{
    p{
      font-size: rem(12);
      line-height: rem(24);
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/AlertDetail.vue